
import { api } from '../core';
import { User, UserRole } from '../../types';
import { localDB } from '../helpers';

export const UserService = {
  getProfile: async (): Promise<User | null> => {
    const storedUser = JSON.parse(localStorage.getItem('lahja_user') || 'null');
    
    return api.execute<any>(
      storedUser?.id ? `/api/V1/ApplicationUser/Get/${storedUser.id}` : '/user/profile', 
      async () => localDB.get<User | null>('lahja_user', null)
    ).then(async (apiUser) => {
        if (!apiUser || !apiUser.id) return apiUser as User | null;

        // Fetch Subscription to determine 'plan'
        try {
            const subs = await api.execute<any[]>('/api/V1/Subscription/GetAllByLanguage', []);
            const activeSub = Array.isArray(subs) ? subs.find((s: any) => s.status === 'active') : null;
            
            let plan: 'free' | 'pro' | 'enterprise' = 'free';
            if (activeSub && activeSub.plan) {
                const planName = activeSub.plan.name?.toLowerCase() || '';
                if (planName.includes('enterprise')) plan = 'enterprise';
                else if (planName.includes('pro')) plan = 'pro';
            }

            // Fix: User type requires 'role' and does not contain 'isAdmin'
            return {
                id: apiUser.id,
                name: apiUser.userName || apiUser.name || 'User',
                email: apiUser.email,
                avatar: apiUser.avatar, 
                plan,
                role: (apiUser.role || (apiUser.isAdmin ? 'admin' : 'user')) as UserRole
            } as User;
        } catch (e) {
            console.warn("Failed to fetch user subscriptions", e);
            // Fallback
            // Fix: User type requires 'role' and does not contain 'isAdmin'
            return {
                id: apiUser.id,
                name: apiUser.userName || 'User',
                email: apiUser.email,
                plan: 'free',
                role: (apiUser.role || (apiUser.isAdmin ? 'admin' : 'user')) as UserRole
            } as User;
        }
    });
  },

  updateProfile: async (updates: Partial<User>): Promise<User> => {
    const storedUser = JSON.parse(localStorage.getItem('lahja_user') || 'null');
    const id = storedUser?.id;

    if (!id) throw new Error("User ID not found");

    const payload = {
        userName: updates.name,
        email: updates.email,
        phoneNumber: (updates as any).phoneNumber
    };

    return api.execute<User>(
      `/api/V1/ApplicationUser/Update/${id}`,
      async () => {
        const currentUser = localDB.get<User | null>('lahja_user', null);
        if (!currentUser) throw new Error('No user found');
        const updated = { ...currentUser, ...updates };
        localDB.set('lahja_user', updated);
        return updated;
      },
      { method: 'PUT', body: { id, body: payload } }
    );
  },

  deleteAccount: async (): Promise<void> => {
    const storedUser = JSON.parse(localStorage.getItem('lahja_user') || 'null');
    const id = storedUser?.id;
    if (!id) return;

    return api.execute<void>(
      `/api/V1/ApplicationUser/Delete/${id}`,
      async () => {
        localStorage.clear();
      },
      { method: 'DELETE' }
    );
  }
};